import { fetchNoteRestrictions, updateAllowedNoteIds } from "../../reducers/noteRestrictionsSlice"
import { fetchNewTopLevelNotesById } from "../../reducers/workspaceNoteSlice"
import { openPrimaryWorkspace, openSecondaryWorkspace } from "../../reducers/workspaceSlice"
import {updateSearches} from "../../reducers/workspaceSearchSlice"

export const noteRestrictionsMiddleware = (socket) => {
	return (storeAPI) => {
		socket.on("UPDATE_NOTE_RESTRICTIONS", async (noteRestrictionsPayload) => {
			// update note permissions
			await storeAPI.dispatch(fetchNewTopLevelNotesById(noteRestrictionsPayload))
			storeAPI.dispatch(updateAllowedNoteIds(noteRestrictionsPayload))

			// check for existing workspace searches in either primary or secondary workspace
			const state = storeAPI.getState()
			const primaryId = state.workspace.primaryId
			const secondaryId = state.workspace.secondaryId
			const workspaceSearches = state.workspaceSearch.byWorkspace
			// if searches exist, update them so search result notes match existing permissions...
			if (workspaceSearches[primaryId]) storeAPI.dispatch(updateSearches(primaryId))
			if (workspaceSearches[secondaryId]) storeAPI.dispatch(updateSearches(secondaryId))
		})
		return next => async action => {
			if (
				action.type === openPrimaryWorkspace.fulfilled.type ||
				action.type === openSecondaryWorkspace.fulfilled.type
			) {
				const state = storeAPI.getState()
				const currentUserId = state.user?.value?.id

				const workspaceId = action.payload.workspace.id

				socket.emit("SUBSCRIBE_TO_NOTE_RESTRICTIONS", {workspaceId, userId: currentUserId})
				storeAPI.dispatch(fetchNoteRestrictions(workspaceId))
			}
			return next(action)
		}
	}
}